var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 176,
    viewBox: "0 0 177 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#completed_svg__filter0_d_3871_29543)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.211,
    y: 26,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#F6F8FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#completed_svg__clip0_3871_29543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.818 102.388H76.75l-2.535-4.392-4.392-2.535v-5.07l-2.535-4.39 2.535-4.392v-5.07l4.392-2.535 2.535-4.392h5.07l4.391-2.535 4.392 2.535h5.07l2.534 4.392 4.392 2.535v5.07L105.133 86l-2.535 4.391v5.07l-4.392 2.535-2.535 4.392h-5.069l-4.392 2.535-4.392-2.535z",
    fill: "#D8E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.21 67.655l4.026 2.324.232.134H95.384l2.324 4.025.133.232.232.134 4.025 2.324V81.744l.134.232L104.556 86l-2.324 4.025-.134.232V95.173l-4.025 2.324-.232.133-.134.232-2.324 4.025H90.467l-.232.134-4.024 2.324-4.025-2.324-.232-.134H77.038l-2.324-4.025-.133-.232-.232-.134-4.025-2.324V90.256l-.134-.232L67.866 86l2.324-4.025.134-.232V76.827l4.025-2.324.232-.133.134-.232 2.324-4.025H81.955l.232-.134 4.024-2.324zm0-1.155l-4.524 2.612H76.46l-2.613 4.525-4.524 2.613v5.225L66.71 86l2.613 4.525v5.225l4.525 2.612 2.613 4.525h5.225l4.524 2.613 4.525-2.612h5.225l2.613-4.525 4.525-2.612v-5.225L105.711 86l-2.613-4.525V76.25l-4.525-2.613-2.612-4.525h-5.225L86.21 66.5z",
    fill: "#2C5BFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#completed_svg__filter1_d_3871_29543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.39 86.052l5.847 5.846L96.39 78.745",
    stroke: "#fff",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "completed_svg__filter0_d_3871_29543",
    x: 0.211,
    y: 0,
    width: 176,
    height: 176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.155 0 0 0 0 0.231506 0 0 0 0 0.516667 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3871_29543"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3871_29543",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "completed_svg__filter1_d_3871_29543",
    x: 72.623,
    y: 75.978,
    width: 28.535,
    height: 24.456,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3871_29543"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3871_29543",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "completed_svg__clip0_3871_29543"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(66.21 66)",
    d: "M0 0h40v40H0z"
  })))));
}
export default __webpack_public_path__ + "media/photographerOnboarding/completed-ee6b6182.svg";
export { SvgCompleted as ReactComponent };